import { createSlice } from '@reduxjs/toolkit';
import { AccountState } from '../types/account.type';
import { confirmAge } from '../actions/account.actions';

export const ACCOUNT_DEFAULT_STATE: AccountState = {
    loading: false,
    isLoggedIn: false,
    accountInfo: {},
    userGated: false,
    isConfirmingAge: false
};

const accountSlice = createSlice({
    name: 'account.info',
    initialState: ACCOUNT_DEFAULT_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(confirmAge.pending, (state) => {
                state.isConfirmingAge = true;
            })
            .addCase(confirmAge.fulfilled, (state) => {
                state.isConfirmingAge = false;
            })
            .addCase(confirmAge.rejected, (state) => {
                state.isConfirmingAge = false;
            });
    }
});

export const accountReducer = accountSlice.reducer;
